/**
 * @file
 * Attaches behaviors for Grille Paragraph
 */

!((Drupal, $) => {

  'use strict';
  Drupal.behaviors.paragraphGrille = {

    attach: function (context) {

      let tablet = 1200;
      let mobilephone = 768;
      let mobileSlide = 2;
      /**
       * Enable slick carousel
       * @param {object} $slickContainer the item container
       * @returns {void}
       */
      function enableSlickCarousel($slickContainer) {
        $slickContainer.slick({
          // eslint-disable-next-line max-len
          nextArrow: '<button uk-icon="icon: chevron-right; ratio: 1.2;" class="slick-next uk-icon uk-button-icon" aria-label="' + Drupal.t('Tuile suivante') + '"></button>',
          // eslint-disable-next-line max-len
          prevArrow: '<button uk-icon="icon: chevron-left; ratio: 1.2;" class="slick-prev uk-icon uk-button-icon" aria-label="' + Drupal.t('Tuile précédente') + '"></button>',
          arrows: true,
          dots: true,
          infinite: false,
          swipeToSlide: true,
          speed: 300,
          slidesToShow: 6,
          slidesToScroll: 6,
          centerMode: false,
          centerPadding: '120px',
          responsive: [
            {
              breakpoint: tablet,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                dots: true,
                arrows: false,
                centerPadding: '30px'
              }
            },
            {
              breakpoint: mobilephone,
              settings: {
                slidesToShow: mobileSlide,
                slidesToScroll: mobileSlide,
                dots: true,
                arrows: false,
                centerPadding: '10px'
              }
            }
          ]
        });
      }

      $(context).find('.grid-elements > div:not(.slick-initialized)').each(function () {
        let screenWidth = $( window ).width();
        let nbElements = $(this).data('element-number');
        if (
          (screenWidth >= tablet && nbElements > 6)
          || (screenWidth >= mobilephone && screenWidth < tablet && nbElements > 4)
          || (screenWidth < mobilephone && nbElements > 2)
        ) {

          mobileSlide = 2;
          if (screenWidth < mobilephone && nbElements === 3) {
            mobileSlide = 1;
          }
          enableSlickCarousel($(this));

          // Manage image and background-color
          let imagesToReload = $(this).find('.node--type--grid-element--teaser');
          imagesToReload.each(function () {
            let bckImage = $(this).data('background-src');
            let bkcColor = $(this).data('background-color');
            if (typeof(bckImage) !== 'undefined' && bckImage) {
              $(this).css('background-image', 'url("'+ bckImage +'")');
            }
            else if (typeof(bkcColor) !== 'undefined' && bkcColor) {
              $(this).css('background-color', bkcColor);
            }
          });
          window.addEventListener("resize", function() {
            imagesToReload.each(function () {
              let bckImage = $(this).data('background-src');
              let bkcColor = $(this).data('background-color');
              if (typeof(bckImage) !== 'undefined' && bckImage) {
                $(this).css('background-image', 'url("'+ bckImage +'")');
              }
              else if (typeof(bkcColor) !== 'undefined' && bkcColor) {
                $(this).css('background-color', bkcColor);
              }
            });
          });
        }
      });
    }
  };
// eslint-disable-next-line no-undef
})(Drupal, jQuery);

